import { Component, effect, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { SpecialOpeningHoursDialogComponent } from './special-opening-hours-dialog/special-opening-hours-dialog.component';
import { ChangedOpeningHoursNotification, OpeningPeriods } from '../../../state-management/model/interfaces/state.model';

@Component({
  selector: 'app-notification-speical-opening-hours',
  standalone: true,
  imports: [],
  templateUrl: './notification-speical-opening-hours.component.html',
  styleUrl: './notification-speical-opening-hours.component.scss'
})
export class NotificationSpeicalOpeningHoursComponent {
  private dialog = inject(MatDialog);
  private readonly data: Signal<ChangedOpeningHoursNotification> = this.websiteState.changedOpeningHoursNotification;
  public readonly relevantDates: {date: string, periods: OpeningPeriods[]}[] = this.data().dates;
  public readonly notificationText = this.data().notificationText;

  constructor(private websiteState: WebsiteStateService) { 
    effect(() => {
      if(this.websiteState.changedOpeningHoursNotification().showNotification && this.websiteState.changedOpeningHoursNotification().dates.length > 0) {
        setTimeout(() => {
          this.dialog.open(SpecialOpeningHoursDialogComponent, {data: { notificationText: this.websiteState.changedOpeningHoursNotification().notificationText, dates: this.websiteState.changedOpeningHoursNotification().dates }}); 
        }, 3000);
      }
    });
  }
}
